module.exports=function(scope){ return `var https = require("https");

callFaceTecAPI("/enrollment/INSERT_ENROLLMENT_IDENTIFIER_HERE", function(error, result) {
  if(error) {
    console.log("Error:" + error);
  }
  else if(result) {
    console.log(result)
  }
})

function callFaceTecAPI(path, callback){
  var options = {
    hostname: "your.internal.zoomserver.instance.url",
    port: 443,
    path: path,
    method: "DELETE",
    headers: {
        "Content-Type": "application/json",
        "X-User-Agent": INSERT_X_USER_AGENT_VALUE_HERE      
    }
  }

  var req = https.request(options, (res) => {
      var output = ""

      res.on("data", (d) => {
          output += d
      })

      res.on("end", () => {
        try{
          var obj = JSON.parse(output)
          callback(undefined, obj)
        }
        catch(error) {
          callback(error, undefined)
        }
      })
  })

  req.on("error", (error) => {
    callback(error, undefined)
  })

  req.end()
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/restsdk-v2/nodejs/enrollment-delete.js.tpl